let control_banner=document.getElementById('termsModal')?.outerHTML;

// Function to get the value of a cookie
function getCookie(name) {
    let cookieArr = document.cookie.split("; ");
    for (let i = 0; i < cookieArr.length; i++) {
        let cookiePair = cookieArr[i].split("=");
        if (cookiePair[0] === name) {
            return cookiePair[1];
        }
    }
    return null;
}

// Function to set a cookie
function setCookie(name, value, days) {
    let date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    let expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

// Check if the terms have been accepted
let termsAccepted = (getCookie("acceptedTerms") === "true");

// Function to create the banner
function createBanner() {
    document.body.appendChild(control_banner);
}

function ensureBannerExists() {
    let banner = document.getElementById('termsModal');
    if (!termsAccepted) {
        document.body.style.overflowY = "hidden";
        if(!document.getElementById('termsModal')){
            createBanner();
        }
        if (control_banner!=banner?.outerHTML){
            banner.outerHTML=control_banner;
        }
    }
    else{
        document.body.style.overflowY = "";
        banner?.remove();

    }
}

// Check every 500ms to ensure the banner hasn't been hidden or removed
ensureBannerExists();
setInterval(ensureBannerExists, 500);

const button = document.querySelector("#acceptTerms");
button?.addEventListener("click", acceptTerms);

function acceptTerms() {
    termsAccepted = true;
    setCookie("acceptedTerms", "true", 365); 
    ensureBannerExists();  
}